import { createTranslations } from '@/i18n/types';

const translations = createTranslations({
  en: {
    link: 'What is this?',
    title: 'How rewards work',
    intro: 'Open cases, do upgrades, top up, come back daily — and unlock achievements. Each one gives you XP for your level and coins on your balance.',
    rule1Title: 'What an achievement gives',
    rule1Body: 'Every achievement you unlock grants XP for your level and coins on your balance.',
    rule2Title: 'Coins follow your top-ups',
    rule2Body: 'Achievement coins are credited as long as their total stays within everything you’ve topped up over all time. No top-ups — no achievement coins.',
    rule3Title: 'A reward can wait',
    rule3Body: 'If your top-ups aren’t enough yet, the achievement still unlocks but its reward stays “not received”. It doesn’t burn — it waits for you.',
    rule4Title: 'Claim after a top-up',
    rule4Body: 'Top up your balance and collect the waiting rewards from “Rewards waiting” at the top. You can claim once your top-ups cover their full amount.',
    footer: 'Rewards already credited are yours to keep.',
  },
  ru: {
    link: 'Что это такое?',
    title: 'Как работают награды',
    intro: 'Открывай кейсы, делай апгрейды, пополняй счёт, заходи каждый день — и получай ачивки. За каждую начисляем опыт (XP) для уровня и монеты на баланс.',
    rule1Title: 'Что даёт ачивка',
    rule1Body: 'За каждую полученную ачивку — опыт (XP) для уровня и монеты на баланс.',
    rule2Title: 'Монеты — в счёт пополнений',
    rule2Body: 'Монеты за ачивки начисляются, пока их общая сумма не больше того, сколько ты пополнил за всё время. Без пополнений монеты за ачивки не приходят.',
    rule3Title: 'Награда может подождать',
    rule3Body: 'Если пополнений пока мало, ачивка всё равно открывается, а её награда остаётся «не полученной». Она не сгорает — ждёт тебя.',
    rule4Title: 'Забери после пополнения',
    rule4Body: 'Пополни баланс и забери накопленные награды через «Награды ждут» вверху. Забрать можно, когда пополнений хватает на всю их сумму сразу.',
    footer: 'Уже начисленные награды никуда не денутся.',
  },
  uz: {
    link: 'Bu nima?',
    title: 'Mukofotlar qanday ishlaydi',
    intro: 'Keyslar och, apgreyd qil, hisobni toʻldir, har kuni kir — va yutuqlarga ega boʻl. Har biri daraja uchun XP va balansga tangalar beradi.',
    rule1Title: 'Yutuq nima beradi',
    rule1Body: 'Har bir ochilgan yutuq daraja uchun XP va balansga tangalar beradi.',
    rule2Title: 'Tangalar toʻldirishga bogʻliq',
    rule2Body: 'Yutuq tangalari ularning umumiy summasi butun vaqt davomida toʻldirgan summangdan oshmaguncha beriladi. Toʻldirmasang — yutuq tangalari kelmaydi.',
    rule3Title: 'Mukofot kutishi mumkin',
    rule3Body: 'Agar toʻldirishlar hali yetarli boʻlmasa, yutuq baribir ochiladi, lekin mukofot «olinmagan» boʻlib qoladi. U yoʻqolmaydi — seni kutadi.',
    rule4Title: 'Toʻldirgandan keyin ol',
    rule4Body: 'Balansni toʻldir va yuqoridagi «Mukofotlar kutmoqda» orqali toʻplangan mukofotlarni ol. Toʻldirishlar ularning toʻliq summasini qoplaganda olish mumkin.',
    footer: 'Allaqachon berilgan mukofotlar seniki boʻlib qoladi.',
  },
  fa: {
    link: 'این چیست؟',
    title: 'جایزه‌ها چطور کار می‌کنند',
    intro: 'کیس باز کن، ارتقا بزن، شارژ کن، هر روز برگرد — و دستاورد باز کن. هر دستاورد به سطحت XP و به موجودیت سکه می‌دهد.',
    rule1Title: 'دستاورد چه می‌دهد',
    rule1Body: 'هر دستاوردی که باز کنی به سطحت XP و به موجودیت سکه می‌دهد.',
    rule2Title: 'سکه‌ها به شارژت وابسته‌اند',
    rule2Body: 'سکه دستاورد تا جایی واریز می‌شود که جمعشان از کل شارژهای همیشگی‌ات بیشتر نشود. شارژ نکرده باشی، سکه دستاورد هم نداری.',
    rule3Title: 'جایزه می‌تواند صبر کند',
    rule3Body: 'اگر شارژهایت هنوز کافی نیست، دستاورد باز می‌شود اما جایزه‌اش «گرفته‌نشده» می‌ماند. نمی‌سوزد — منتظرت می‌ماند.',
    rule4Title: 'بعد از شارژ بگیرش',
    rule4Body: 'موجودیت را شارژ کن و جایزه‌های منتظر را از «جایزه‌ها منتظرند» در بالا بردار. وقتی شارژهایت کل مبلغشان را پوشش داد، می‌توانی بگیری.',
    footer: 'جایزه‌هایی که واریز شده‌اند مال خودت می‌مانند.',
  },
  pt: {
    link: 'O que é isso?',
    title: 'Como funcionam as recompensas',
    intro: 'Abra caixas, faça upgrades, deposite, entre todo dia — e conquiste conquistas. Cada uma dá XP para o seu nível e moedas no saldo.',
    rule1Title: 'O que uma conquista dá',
    rule1Body: 'Cada conquista desbloqueada dá XP para o nível e moedas no saldo.',
    rule2Title: 'Moedas acompanham os depósitos',
    rule2Body: 'As moedas das conquistas são creditadas enquanto o total delas não passar de tudo o que você já depositou. Sem depósitos, as moedas das conquistas não chegam.',
    rule3Title: 'A recompensa pode esperar',
    rule3Body: 'Se os depósitos ainda não bastam, a conquista é desbloqueada mesmo assim, mas a recompensa fica como “não recebida”. Ela não expira — fica esperando você.',
    rule4Title: 'Pegue depois de depositar',
    rule4Body: 'Deposite e pegue as recompensas acumuladas em “Recompensas pendentes” no topo. Dá para pegar quando os depósitos cobrem o valor total delas de uma vez.',
    footer: 'As recompensas já creditadas são suas.',
  },
  tr: {
    link: 'Bu ne?',
    title: 'Ödüller nasıl çalışır',
    intro: "Kasa aç, upgrade yap, bakiye yükle, her gün gir — ve başarım kazan. Her biri için seviye XP'si ve bakiyene coin veriyoruz.",
    rule1Title: 'Başarım ne verir',
    rule1Body: "Kazandığın her başarım için seviye XP'si ve bakiyene coin.",
    rule2Title: 'Coinler yüklemelere bağlı',
    rule2Body: 'Başarım coinleri, toplamları tüm zamanlarda yüklediğin miktarı aşmadığı sürece yatırılır. Yükleme yoksa başarım coinleri gelmez.',
    rule3Title: 'Ödül bekleyebilir',
    rule3Body: 'Yüklemeler henüz yetmiyorsa başarım yine açılır ama ödülü “alınmadı” olarak kalır. Yanmaz — seni bekler.',
    rule4Title: 'Yüklemeden sonra al',
    rule4Body: 'Bakiye yükle ve biriken ödülleri üstteki “Ödüller bekliyor” bölümünden al. Yüklemeler ödüllerin toplam tutarını tek seferde karşıladığında alabilirsin.',
    footer: 'Zaten yatırılmış ödüller hiçbir yere gitmez.',
  },
  uk: {
    link: 'Що це таке?',
    title: 'Як працюють нагороди',
    intro: 'Відкривай кейси, роби апгрейди, поповнюй рахунок, заходь щодня — і отримуй досягнення. За кожне нараховуємо досвід (XP) для рівня та монети на баланс.',
    rule1Title: 'Що дає досягнення',
    rule1Body: 'За кожне отримане досягнення — досвід (XP) для рівня та монети на баланс.',
    rule2Title: 'Монети — в межах поповнень',
    rule2Body: 'Монети за досягнення нараховуються, поки їхня загальна сума не перевищує того, скільки ти поповнив за весь час. Без поповнень монети за досягнення не приходять.',
    rule3Title: 'Нагорода може почекати',
    rule3Body: 'Якщо поповнень поки мало, досягнення все одно відкривається, а його нагорода лишається «не отриманою». Вона не згорає — чекає на тебе.',
    rule4Title: 'Забери після поповнення',
    rule4Body: 'Поповни баланс і забери накопичені нагороди через «Нагороди чекають» угорі. Забрати можна, коли поповнень вистачає на всю їхню суму одразу.',
    footer: 'Уже нараховані нагороди нікуди не подінуться.',
  },
  de: {
    link: 'Was ist das?',
    title: 'So funktionieren Belohnungen',
    intro: 'Öffne Cases, nutze Upgrades, lade auf, komm jeden Tag vorbei — und sammle Trophäen. Für jede gibt es Erfahrung (XP) fürs Level und Münzen aufs Guthaben.',
    rule1Title: 'Was eine Trophäe bringt',
    rule1Body: 'Für jede erhaltene Trophäe gibt es Erfahrung (XP) fürs Level und Münzen aufs Guthaben.',
    rule2Title: 'Münzen richten sich nach Aufladungen',
    rule2Body: 'Trophäen-Münzen werden gutgeschrieben, solange ihre Gesamtsumme nicht höher ist als alles, was du insgesamt aufgeladen hast. Ohne Aufladungen gibt es keine Trophäen-Münzen.',
    rule3Title: 'Eine Belohnung kann warten',
    rule3Body: 'Reichen deine Aufladungen noch nicht, wird die Trophäe trotzdem freigeschaltet, ihre Belohnung bleibt aber „nicht abgeholt“. Sie verfällt nicht — sie wartet auf dich.',
    rule4Title: 'Nach dem Aufladen abholen',
    rule4Body: 'Lade dein Guthaben auf und hole die wartenden Belohnungen oben über „Belohnungen warten“ ab. Das geht, sobald deine Aufladungen die ganze Summe auf einmal abdecken.',
    footer: 'Bereits gutgeschriebene Belohnungen bleiben dir erhalten.',
  },
  es: {
    link: '¿Qué es esto?',
    title: 'Cómo funcionan las recompensas',
    intro: 'Abre cajas, haz upgrades, recarga tu saldo y entra cada día: así consigues logros. Por cada uno te damos experiencia (XP) para tu nivel y monedas en tu saldo.',
    rule1Title: 'Qué da un logro',
    rule1Body: 'Por cada logro que consigues recibes experiencia (XP) para tu nivel y monedas en tu saldo.',
    rule2Title: 'Las monedas dependen de tus recargas',
    rule2Body: 'Las monedas por logros se acreditan mientras su suma total no supere lo que has recargado en toda tu cuenta. Sin recargas, no llegan monedas por logros.',
    rule3Title: 'La recompensa puede esperar',
    rule3Body: 'Si aún tienes pocas recargas, el logro se desbloquea igualmente, pero su recompensa queda como «sin recoger». No caduca: te espera.',
    rule4Title: 'Recógela tras recargar',
    rule4Body: 'Recarga tu saldo y recoge las recompensas acumuladas en «Recompensas pendientes», arriba. Puedes recogerlas cuando tus recargas cubran toda la suma de una vez.',
    footer: 'Las recompensas ya acreditadas no se pierden.',
  },
  pl: {
    link: 'Co to jest?',
    title: 'Jak działają nagrody',
    intro: 'Otwieraj skrzynki, rób upgrade\'y, doładowuj konto, wchodź codziennie — i zdobywaj osiągnięcia. Za każde naliczamy doświadczenie (XP) na poziom i monety na saldo.',
    rule1Title: 'Co daje osiągnięcie',
    rule1Body: 'Za każde zdobyte osiągnięcie dostajesz doświadczenie (XP) na poziom i monety na saldo.',
    rule2Title: 'Monety w ramach doładowań',
    rule2Body: 'Monety za osiągnięcia są naliczane, dopóki ich łączna suma nie przekroczy tego, ile doładowałeś konto przez cały czas. Bez doładowań monety za osiągnięcia nie przychodzą.',
    rule3Title: 'Nagroda może poczekać',
    rule3Body: 'Jeśli doładowań jest jeszcze mało, osiągnięcie i tak się odblokuje, a jego nagroda zostanie „nieodebrana”. Nie przepada — czeka na ciebie.',
    rule4Title: 'Odbierz po doładowaniu',
    rule4Body: 'Doładuj saldo i odbierz zebrane nagrody przez „Nagrody czekają” na górze. Odebrać możesz, gdy doładowań starcza na ich całą sumę naraz.',
    footer: 'Już naliczone nagrody nigdzie nie znikną.',
  },
});

export default translations;
